import { Link } from "react-router-dom";
import "./HerlevSeo.css";
import Seo from "../../../Seo/Seo";
import {
    webPageSchema,
    serviceSchema,
} from "../../../Seo/jsonld";
import { getRouteSeo } from "../../../Seo/routeSeo";

const SoborgSkolemad = () => {
    const PATH = '/skolemad-soborg'
    return (
        <>
            <Seo
                path={PATH}
                jsonLd={[
                    webPageSchema({
                        title: getRouteSeo(PATH)?.title,
                        description: getRouteSeo(PATH)?.description,
                        url: PATH,
                    }),
                    serviceSchema({
                        name: "Skolemad og Madordninger i Søborg",
                        description: getRouteSeo(PATH)?.description,
                        url: PATH,
                        areaServed: "Søborg",
                    }),
                ]}
            />
            <main className="herlev-page remove-space">
                <section className="herlev-hero">
                    <div className="herlev-hero-shape herlev-hero-shape-one" />
                    <div className="herlev-hero-shape herlev-hero-shape-two" />
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-7">
                                <div className="herlev-hero-copy wow fadeInUp">
                                    <span className="herlev-kicker">Skolemad og Madordninger i Søborg</span>
                                    <h1>Skolemad og Madordninger i Søborg – Pålidelig Forplejning til Skoler, Institutioner og Virksomheder</h1>
                                    <div className="herlev-rule"><span /><span /></div>
                                    <p className="herlev-lead">
                                        Søborg er kendt for sine etablerede skoler, velfungerende institutioner og et tæt-knit samfund. Når man driver en skole, institution eller virksomhed her, handler det også om at kunne stole på sine leverandører.
                                    </p>
                                    <p className="herlev-lead">
                                        Onlineskolemad leverer skolemad, madordninger og catering til Søborg. Vi forstår, at pålidelighed og kvalitet betyder noget – og vi bygger vores service netop på disse værdier. Uanset om du er forælder, skoleleder, institutionschef eller virksomhedsejer, handler det om at kunne stole på, at maden kommer, når det er aftalt, og at den holder den kvalitet, som dine elever, brugere eller medarbejdere fortjener.
                                    </p>
                                    <div className="herlev-actions">
                                        <Link className="herlev-text-link" to="/contact">Kontakt os og lær hvordan det virker <i className="fas fa-arrow-right" /></Link>
                                    </div>
                                    <div className="herlev-trust-row">
                                        <span><i className="fas fa-check-circle" /> Egne chauffører</span>
                                        <span><i className="fas fa-check-circle" /> Online bestilling</span>
                                        <span><i className="fas fa-check-circle" /> Halal</span>
                                    </div>
                                    <div className="flex-group play-app row">
                                        <div className="col-md-6 ">
                                            <Link className="btn btn-dark google_ply mb-3" target="blank" to={'https://apps.apple.com/dk/app/onlineskolemad/id6741146828?l=da'}>
                                                <span className="play_img">
                                                    <img src="/assets/img/apple-icon.svg" alt="not found" />
                                                </span>
                                                <div className="download-cont">
                                                    <span>Download i</span>
                                                    <p>Appstore</p>
                                                </div>
                                            </Link>
                                            <img className="qr-img" src="/assets/img/qr-ios.png" />
                                        </div>
                                        <div className="col-md-6 mt-md-0 mt-4 mb-md-0 mb-5">
                                            <Link className="btn btn-dark google_ply mb-3" target="blank" to={'http://play.google.com/store/apps/details?id=com.onlineskolemad&hl=en'}>
                                                <span className="play_img">
                                                    <img src="/assets/img/palystore-icon.svg" alt="not found" />
                                                </span>
                                                <div className="download-cont">
                                                    <span>Hent den i</span>
                                                    <p>Google Play</p>
                                                </div>
                                            </Link>
                                            <img className="qr-img" src="/assets/img/qr-android.png" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <div className="herlev-hero-image wow fadeInRight">
                                    <img src="/assets/img/childrens-2.png" alt="Børn, der nyder skolemad" />
                                    <div className="herlev-hero-note"><strong>2730</strong><span>Ballerup</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="herlev-intro sec-pd">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <div className="herlev-photo-frame wow fadeInLeft">
                                    <img src="/assets/img/food-1.png" alt="Frisk skolemad fra Onlineskolemad" />
                                    <span className="herlev-photo-stamp"><i className="fas fa-heart" /> Gør frokosten lettere</span>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="herlev-copy-block wow fadeInUp">
                                    <span className="herlev-eyebrow">Hvorfor Pålidelig Forplejning Betyder Noget I Søborg</span>
                                    <h2>Hvorfor Pålidelig Forplejning Betyder Noget I Søborg</h2>
                                    <div className="herlev-rule"><span /><span /></div>
                                    <p>
                                        Søborg er et område med høje standarder. Der er mange etablerede skoler, hvor forældre vælger at sende deres børn med det formål, at de skal få ordentlig undervisning og omsorg. Der er institutioner, som passer sårbare grupper – ældre, børn, mennesker med særlige behov. Der er virksomheder, som ønsker at behandle deres medarbejdere godt.
                                    </p>
                                    <p>
                                        I sådan et miljø sker der ikke meget ved at sige "vi er billigst" eller "vi har en app." Det handler om det grundlæggende: at levere hvad man lover, at tage små detaljer alvorligt, at have øje for kvalitet.
                                    </p>
                                    <p>
                                        En skolemadordning i Søborg skal være mere end bare mad på tiden. Den skal være en service, som skoler kan være trygge ved. Den skal være rugbrød, ikke flueben – solid og pålidelig, dag efter dag.
                                    </p>
                                    <p>
                                        For forældre i området betyder det, at de kan være sikre på, at deres barn får en ordentlig frokost uden, at de selv skal tilberede det hver dag. For institutioner betyder det, at de kan fokusere på deres kerneopgave i stedet for at administrere køkkenet. For virksomheder betyder det, at de kan tilbyde deres ansatte noget, som tæller.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="herlev-pale-section sec-pd">
                    <div className="container">
                        <div className="herlev-section-heading">
                            <span className="herlev-eyebrow">Noget for enhver frokost</span>
                            <h2>Søborgs Skoler, Institutioner og Forplejningsbehov</h2>
                        </div>
                        <div className="row">
                            <div className="col-md-6 col-lg-4">
                                <article className="herlev-menu-item wow fadeInUp" data-wow-delay="0s">
                                    <span className="herlev-menu-icon"><i className="fas fa-utensils" /></span>
                                    <div><h3>Søborg har en solid struktur af uddannelses- </h3><p>og omsorginstitutioner. Grundskole, privatskole, børnefamilier, ældrecentre, aktivitetssteder – der er mange mennesker, som skal spise ordentligt hver dag.</p></div>
                                </article>
                            </div>
                            <div className="col-md-6 col-lg-4">
                                <article className="herlev-menu-item wow fadeInUp" data-wow-delay="0s">
                                    <span className="herlev-menu-icon"><i className="fas fa-utensils" /></span>
                                    <div><h3>Skolerne i Området</h3><p>Søborg har skoler på alle niveauer. Elever skal have frokost – det er simpelt faktisk. Nogle forældre kan tilberede madpakker, andre ønsker sig en løsning, hvor maden er sikret uden deres direkte indsats. Skoler kan få aflastet en administrativ opgave ved at få skolemaden leveret.</p></div>
                                </article>
                            </div>
                            <div className="col-md-6 col-lg-4">
                                <article className="herlev-menu-item wow fadeInUp" data-wow-delay="0.08s">
                                    <span className="herlev-menu-icon"><i className="fas fa-bread-slice" /></span>
                                    <div><h3>Institutioner og Omsorgtilbud</h3><p>Fra børnehaver til plejecentre finder man institutioner, som skal sikre ernæring og komfortabel hverdagskost for deres brugere. En konstant, pålidelig madleverandør frigør ressourcer, som institutionen kan bruge til selve omsorgen.</p></div>
                                </article>
                            </div>
                            <div className="col-md-6 col-lg-4">
                                <article className="herlev-menu-item wow fadeInUp" data-wow-delay="0.16s">
                                    <span className="herlev-menu-icon"><i className="fas fa-box" /></span>
                                    <div><h3>Lokale Virksomheder</h3><p>Søborg har virksomheder – fra mindre kontorer til større arbejdspladser. Mange medarbejdere pendler, nogle arbejder lokalt. En frokostordning, som virksomheden ikke selv skal administrere, er en måde at tage sig af sine ansatte på.</p></div>
                                </article>
                            </div>
                            <div className="col-md-6 col-lg-4">
                                <article className="herlev-menu-item wow fadeInUp" data-wow-delay="0.24s">
                                    <span className="herlev-menu-icon"><i className="fas fa-leaf" /></span>
                                    <div><h3>Organisationer og Mødefaciliteter</h3><p>Også foreninger, vejkredse, og lokale organisationer har brug for mad – til møder, arrangementer, eller daglige drift. Søborg er kort sagt et område, hvor der er konstant behov for ordnet, pålidelig forplejning på tværs af institutioner.</p></div>
                                </article>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="herlev-audience sec-pd">
                    <div className="container">
                        <div className="row align-items-end mb-4">
                            <div className="col-lg-8">
                                <span className="herlev-eyebrow">En løsning til hverdagen</span>
                                <h2>Hvad Kan Onlineskolemad Tilbyde Til Søborg?</h2>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <article className="herlev-audience-card">
                                    <span>01</span>
                                    <h3>Skolemad og Skolefrokost</h3>
                                    <p>Skoler i Søborg kan få leveret daglig skolemad uden selv at skulle administrere bestilling, levering eller tilberedning (medmindre de ønsker det). Vi sørger for:</p>
                                    <ul className="herlev-check-list">
                                        <li>Varieret menuplanlægning – så eleverne får forskelligt at spise og får ordentlig ernæring</li>
                                        <li>Præcis levering – til skolens tider, så der ikke er dødtid</li>
                                        <li>Tilpasning til elevgrupppen – børn har andre behov end teenagere</li>
                                        <li>Håndtering af allergier og ønsker – vi noterer og respekterer eventuelle behov</li>
                                        <li>Enkel administraton for skolekøkkenet – alt er forudplanlagt</li>
                                    </ul>
                                    <p>
                                        En skole kan fokusere på undervisning. Eleverne får deres frokost. Forældre ved, at der er taget sig af maden. Alle er tilfredse.
                                    </p>
                                    <Link to="/contact">Læs mere om skolemadordninger <i className="fas fa-arrow-right" /></Link>
                                </article>
                            </div>
                            <div className="col-md-4">
                                <article className="herlev-audience-card">
                                    <span>02</span>
                                    <h3>Madordning til Institutioner</h3>
                                    <p>Plejecentre, dagcentre, fritidshjem, og andre institutioner i Søborg kan få deres daglige madordning håndteret af os. Vi tilbyder:</p>
                                    <ul className="herlev-check-list">
                                        <li>Professionel madtilberedning – så institutionen kan fokusere på kerneopgaven</li>
                                        <li>Ernæring tilpasset brugergruppen – børn, ældre, mennesker med særlige behov</li>
                                        <li>Fleksibel bestilling – ændring af antal portioner efter behov</li>
                                        <li>Pålidelig levering – hver dag præcis som aftalt</li>
                                        <li>Reduceret administrativ belastning – institutionen slipper for køkkendrift</li>
                                    </ul>
                                    <Link to="/contact">Udforsk kantineordninger for institutioner<i className="fas fa-arrow-right" /></Link>
                                </article>
                            </div>
                            <div className="col-md-4">
                                <article className="herlev-audience-card">
                                    <span>03</span>
                                    <h3>Frokostordning til Virksomheder og Kontorer</h3>
                                    <p>Virksomheder i Søborg kan tilbyde deres medarbejdere daglig frokost uden selv at skulle administrere det. Fordele:</p>
                                    <ul className="herlev-check-list">
                                        <li>Høj medarbejdertilfredshed – folk værdsætter en arbejdsgiver, der passer på dem</li>
                                        <li>Reduceret administrativt arbejde – alt sker uden indgriben fra HR eller økonomi</li>
                                        <li>Konkurrencekraft i talentjagten – gode ydelser hjælper med at tiltrække og fastholde medarbejdere</li>
                                        <li>Enkel økonomi – gennemsigtig prisfastsættelse, fakturering</li>
                                    </ul>
                                    <Link to="/contact">Se hvordan virksomheder bruger frokostordninger <i className="fas fa-arrow-right" /></Link>
                                </article>
                            </div>
                            <div className="col-md-4">
                                <article className="herlev-audience-card">
                                    <span>04</span>
                                    <h3>Catering til Arrangementer og Møder</h3>
                                    <p>Når institutioner, virksomheder eller organisationer i Søborg skal holde møde, fest eller arrangement, kan vi levere catering. Vi laver:</p>
                                    <ul className="herlev-check-list">
                                        <li>Planlagte menuer – tilpasset dit arrangement og dine gæster</li>
                                        <li>Professionel præsentation – maden kommer ikke blot i plastikbakker</li>
                                        <li>Fleksible ordninger – fra mindre møder til større fester</li>
                                        <li>Punkt-til-punkt levering – vi udbringer og pakker ind</li>
                                    </ul>
                                    <Link to="/contact">vide mere <i className="fas fa-arrow-right" /></Link>
                                </article>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="herlev-situation-section sec-pd">
                    <div className="container">
                        <div className="herlev-section-heading">
                            <span className="herlev-eyebrow">Madordninger til forskellige behov</span>
                            <h2>Når Søborg-Institutioner og -Virksomheder Søger Madordning</h2>
                            <div className="herlev-rule"><span /><span /></div>
                            <p>Ikke alle har brug for det samme. En skole har andre behov end et kontor. En institution med ældre har andre behov end en børnehave. Her er et overblik:</p>
                        </div>
                        <div className="herlev-situation-table-wrap">
                            <table className="herlev-situation-table">
                                <thead>
                                    <tr>
                                        <th scope="col">Situation</th>
                                        <th scope="col">Passende Løsning</th>
                                        <th scope="col">Hvorfor</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td data-label="Situation">Grundskole med 300 elever som skal have daglig frokost</td>
                                        <td data-label="Passende løsning"><strong>Skolemad / skolefrokost</strong></td>
                                        <td data-label="Hvorfor">Fast leveringsplan, antal portioner, menuer tilpasset aldersgruppe</td>
                                    </tr>
                                    <tr>
                                        <td data-label="Situation">Kontor i Søborg hvor medarbejdere arbejder hele dagen</td>
                                        <td data-label="Passende løsning"><strong>Frokostordning</strong></td>
                                        <td data-label="Hvorfor">Fleksibel bestilling, levering til adressen, medarbejderne blot høster gevinsten</td>
                                    </tr>
                                    <tr>
                                        <td data-label="Situation">Plejecenter som skal servicere 80 beboere med mad</td>
                                        <td data-label="Passende løsning"><strong>Kantineordning / forplejning</strong></td>
                                        <td data-label="Hvorfor">Ernæring, variation, administrationsfrihed, tilpasning til brugergruppe</td>
                                    </tr>
                                    <tr>
                                        <td data-label="Situation">Virksomhed som skal afholde møde eller årsfest</td>
                                        <td data-label="Passende løsning"><strong>Catering</strong></td>
                                        <td data-label="Hvorfor">Skræddersyet, færdigpakket, opsætningshjælp</td>
                                    </tr>
                                    <tr>
                                        <td data-label="Situation">Børnehave som skal tilbyde frugtsnack eller frokost</td>
                                        <td data-label="Passende løsning"><strong>Madordning</strong></td>
                                        <td data-label="Hvorfor">Tilpasset små børns behov, enkel bestilling, pålidelig levering</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <p className="herlev-situation-note mt-1">Dette er blot nogle få eksempler. Kontakt os hvis dine behov ikke helt passer ind i skemaet – vi finder ofte på en løsning alligevel.</p>
                    </div>
                </section>

                <section className="herlev-steps sec-pd">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-5">
                                <div className="herlev-copy-block">
                                    <h2>Fra Første Kontakt til Pålidelig Madlevering</h2>
                                    <div className="herlev-rule"><span /><span /></div>
                                    <Link className="btn btn-1" to="/signup">Opret bruger</Link>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="herlev-step-list">
                                    <div className="herlev-step">
                                        <span>01</span>
                                        <div>
                                            <h3>Du Tager Initiativet</h3>
                                            <p>Ring eller skriv. Fortæl hvad du har behov for. "Vi skal have skolemad til 250 elever," eller "Vi søger frokostordning til 25 ansatte," eller "Vi skal have catering til vores årsmøde."</p>
                                        </div>
                                    </div>
                                    <div className="herlev-step">
                                        <span>02</span>
                                        <div>
                                            <h3>Vi Lytter og Spørger</h3>
                                            <p>Vi ønsker at forstå dit behov helt. Hvor mange personer? Hvilke dage? Hvordan skal maden leveres? Skal der være særlige menuvarianter? Vi stiller spørgsmål, som betyder noget.</p>
                                        </div>
                                    </div>
                                    <div className="herlev-step">
                                        <span>03</span>
                                        <div>
                                            <h3>Vi Foreslår Konkret</h3>
                                            <p>På baggrund af hvad du fortæller, laver vi et konkret forslag. Menuer, antal portioner, pris, levering. Alt er dokumenteret.</p>
                                        </div>
                                    </div>
                                    <div className="herlev-step">
                                        <span>04</span>
                                        <div>
                                            <h3>Du Godkender eller Justerer</h3>
                                            <p>Hvis forslaget passer, siger du ja. Hvis du ønsker ændringer, justerer vi. Der er intet "tag det eller lad det."</p>
                                        </div>
                                    </div>
                                    <div className="herlev-step">
                                        <span>05</span>
                                        <div>
                                            <h3>Vi Starter</h3>
                                            <p>Fra startdatoen leverer vi som aftalt. Hver dag. Pålidigt. Hvis der kommer ændringer i dine behov, kan du kontakte os – vi justerer.</p>
                                        </div>
                                    </div>
                                    <div className="herlev-step">
                                        <span>06</span>
                                        <div>
                                            <h3>Løbende Support</h3>
                                            <p>Du er ikke alene efter aftalen starter. Hvis spørgsmål opstår, hvis behov ændrer sig, hvis du ønsker at drøfte noget – vi er her.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p>Processen er ligetil. Vi gør det ikke mere kompliceret end nødvendigt.</p>
                        </div>
                    </div>
                </section>

                <section className="herlev-reasons sec-pd">
                    <div className="container">
                        <div className="herlev-reasons-heading">
                            <div>
                                <span className="herlev-eyebrow">Det Gør os til dit Naturlige Valg i SØBORG</span>
                                <h2>Det, Som Gør Forskellen</h2>
                            </div>
                        </div>
                        <div className="herlev-reasons-grid">
                            <article className="herlev-reason-card">
                                <div className="herlev-reason-number">01</div>
                                <div className="herlev-reason-icon"><i className="fas fa-school" /></div>
                                <div>
                                    <h3>Pålidelighed Som Værdi</h3>
                                    <p>Søborg-området værdsætter institutioner og virksomheder, der kan stå for deres ord. Vi leverer. Hvis vi siger, at maden kommer kl. 11.30, så kommer den kl. 11.30. Ikke kl. 11.45. Ikke næste dag. Vi forstår, at institutioner og virksomheder bygger deres rutiner på os.</p>
                                </div>
                            </article>
                            <article className="herlev-reason-card">
                                <div className="herlev-reason-number">02</div>
                                <div className="herlev-reason-icon"><i className="fas fa-utensils" /></div>
                                <div>
                                    <h3>Kvalitet I Maden</h3>
                                    <p>Vi bruger ingredienser, som vi selv ville give vores børn eller medarbejdere. Det er ikke et slagord – det er hvad vi gør. Maden skal smage godt, være sund, og være lavet med omsorg.</p>
                                </div>
                            </article>
                            <article className="herlev-reason-card">
                                <div className="herlev-reason-number">03</div>
                                <div className="herlev-reason-icon"><i className="fas fa-mobile-alt" /></div>
                                <div>
                                    <h3>Fleksibilitet Uden Hysteri</h3>
                                    <p>Vi er ikke stive. Hvis en skole har brug for mindre mad en uge pga. aktiviteter, accepterer vi det. Hvis et kontor skal have ekstra portioner pludselig, forsøger vi at imødekomme det. Fleksibilitet er vigtig – men altid inden for rimelighedens grænser.</p>
                                </div>
                            </article>
                            <article className="herlev-reason-card">
                                <div className="herlev-reason-number">04</div>
                                <div className="herlev-reason-icon"><i className="fas fa-leaf" /></div>
                                <div>
                                    <h3>Transparent Kommunikation</h3>
                                    <p>Du ved hvad du betaler for. Du ved hvad du får. Der er ikke skjulte omkostninger eller overraskelser. Vi kommunikerer klart på dansk og uden unødig jargon.</p>
                                </div>
                            </article>
                            <article className="herlev-reason-card">
                                <div className="herlev-reason-number">05</div>
                                <div className="herlev-reason-icon"><i className="fas fa-map-marker-alt" /></div>
                                <div>
                                    <h3>Lokal Relevans</h3>
                                    <p>Vi er ikke en stor maskine, der behandler Søborg som et tal blandt 100 andre byer. Vi forstår området. Vi kender dets behov. Og vi bygger vores service rundt om det.</p>
                                </div>
                            </article>
                        </div>
                    </div>
                </section>

                <section className="sec-pd rel-z-1">
                    <div className="top-bottom-shaps">
                        <span className="shap shap-1" />
                        <span className="shap shap-2" />
                    </div>
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-6 mmb-20">
                                <div className="img-style-1 wow fadeInLeft">
                                    <img src="/assets/img/about-1.png" alt="Not found" />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div>
                                    <div
                                        className="title-1 wow fadeInRight"
                                        data-wow-delay="0.1s"
                                        style={{
                                            visibility: "visible",
                                            animationDelay: "0.1s",
                                            animationName: "fadeInUp",
                                        }}
                                    >
                                        <h1>Madlevering I Søborg – Sådan Arbejder Vi Lokalt</h1>
                                        <div className="herlev-rule"><span /><span /></div>
                                        <p>
                                        </p>
                                        <div className="mt-3">
                                            <p>
                                                Vi leverer til hele Søborg Kommune. Enten du er på den nordlige eller sydlige side af området, kan vi nå dig.
                                            </p>
                                            <ol>
                                                <li> <strong> For Skoler:</strong> Vi koordinerer med skolens timeplan. Maden ankommer til det aftalt tidspunkt, enten til skolekøkkenet eller direkte til spisesalen, alt efter hvad der passer bedst.</li>
                                                <li> <strong> For Institutioner:</strong> Vi tilpasser leveringstiderne til institutionens rutiner. En børnehave kan have maden klokken 11.30, et plejecenter kan have flere leveringer hvis det passer bedre.</li>
                                                <li> <strong> For Virksomheder:</strong> Vi leverer til kontoradressen på dagen eller timerne, som virksomheden ønsker.</li>
                                                <li> <strong> For Arrangementer:</strong> Vi aftalte punkt-til-punkt levering på dagen for dit arrangement.</li>
                                            </ol>
                                            <p>Hvis du er usikker på, om vi kan nå dit område i Søborg, kontakt os. Vi giver direkte svar i stedet for at lade dig gætte.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="herlev-faq sec-pd">
                    <div className="container">
                        <div className="herlev-section-heading"><span className="herlev-eyebrow">Spørgsmål og svar</span><h2>Dit Spørgsmål Er Sandsynligvis Allerede Besvaret Her</h2></div>
                        <div className="herlev-faq-list">
                            <details open>
                                <summary>Kan skoler i Søborg få skolemad leveret dagligt?<i className="fas fa-plus" /></summary>
                                <p>Ja. Vi leverer skolemad til skoler i Søborg hver dag. Du bestemmer hvilke dage og hvilken tidspunkt. Levering kan ske til skolekøkkenet eller direkte til spisesteder.</p>
                            </details>
                            <details>
                                <summary>Hvordan håndterer I børn med allergier eller særlige kosttyper?<i className="fas fa-plus" /></summary>
                                <p>Vi noterer alle allergier og ønsker (vegetarisk, veganistisk, halal osv.) og tilberedt maden derefter. Der sker ingen fejl – vi tager det seriøst.</p>
                            </details>
                            <details>
                                <summary>Hvad hvis en institution skal have mindre mad en gang i mellem?<i className="fas fa-plus" /></summary>
                                <p>Kontakt os – normalt kan vi justere bestillingen. Havde I lagt op til 80 portioner, men denne uge skal det kun være 70, accepterer vi det. Hyppige og drastiske ændringer gør det vanskeligt, men rimelige justeringer er helt OK.</p>
                            </details>
                            <details>
                                <summary>Hvor lang tid tager det at starte en madordning?<i className="fas fa-plus" /></summary>
                                <p>Det afhænger af hvor travlt vi er. Typisk kan vi finde tid til et møde inden for få dage, og en ordning kan starte 2-3 uger efter aftalen. Hvis du har brug for at starte hurtigere, fortæl os – vi gør hvad vi kan.</p>
                            </details>
                            <details>
                                <summary>Hvad koster skolemad og madordninger?<i className="fas fa-plus" /></summary>
                                <p>Priserne afhænger helt af hvad du har behov for – antal portioner, type mad, leveringshyppighed osv. Vi giver konkrete tilbud efter at have forstået dine behov. Der er ingen skjulte gebyrer.</p>
                            </details>
                            <details>
                                <summary>Kan virksomheder i Søborg få frokost leveret til deres kontorer?<i className="fas fa-plus" /></summary>
                                <p>Ja. Vi leverer frokost til virksomheder i Søborg. Du kan vælge mellem faste menuer eller lade medarbejdere bestille individuelt. Vi tilbyder begge modeller.</p>
                            </details>
                            <details>
                                <summary>Tilbyder I catering til større arrangementer?<i className="fas fa-plus" /></summary>
                                <p>Ja. Fra møder til fester kan vi levere catering. Du kontakter os med dato, gæstetal og ønsker til menuer, og vi laver et forslag.</p>
                            </details>
                            <details>
                                <summary>Hvordan bestiller man når først ordningen er startet?<i className="fas fa-plus" /></summary>
                                <p>Du får adgang til vores bestillingssystem. Du logger ind, ser dagens menuer, og bekræfter antal portioner. Det tager 2 minutter. Ikke mere kompliceret end det.</p>
                            </details>
                            <details>
                                <summary>Leverer I også til eventos og private arrangementer i Søborg?<i className="fas fa-plus" /></summary>
                                <p>Vi fokuserer primært på skoler, institutioner og virksomheder, men kontakt os hvis du har et større privatarrangement – vi finder ofte på en løsning.</p>
                            </details>
                        </div>
                    </div>
                </section>

                <section className="herlev-cta">
                    <div className="container">
                        <div className="herlev-cta-inner"><div>
                            <span className="herlev-eyebrow">Lokalt forankret i Soborg</span>
                            <h2>Lad os Høre Om Dit Behov</h2>
                            <p>Søborg fortjener pålidelig forplejning. Du fortjener at kunne fokusere på det, du gør bedst – ikke på at administrere madordninger.</p>
                            <p>Om du står bag en skolekasse, en institution, en virksomhed eller en organisation – kontakt os. Vi lytter, vi foreslår, vi leverer.</p>
                            <br />
                            <p>Der er intet at tabe ved at høre hvad vi kan tilbyde.</p>
                        </div>
                            <div className="herlev-cta-actions">
                                <Link className="btn btn-1" to="/contact">Kontakt Onlineskolemad</Link>
                                <a href="tel:26227469">Telefon: 26 22 74 69</a>
                                <a href="/">Adresse: Herlev Bygade 27, 2730 Herlev</a>
                                <a href="/">E-mail: onlineskolemad@hotmail.com</a>
                            </div>
                        </div>
                    </div>
                </section>
            </main >
        </>
    )
}

export default SoborgSkolemad